import React, { Component } from "react";
import jsonData from "../JasonData/G5TableData.json";
import InquiryPopup from "../component/InquiryForm";
import PDFJSON from "../JasonData/PDFURL.json";

const proimage = require("../../images/product/G10/G10.png");
const proimage1 = require("../../images/product/G10/G10-2.png");
const proimage2 = require("../../images/product/G10/heating-g-5-g-10-g-20.jpg");
const imgIcon = require("../../images/product/icon-1.png");

const handleDownload = () => {
  const link = document.createElement("a");
  link.href = process.env.PUBLIC_URL + PDFJSON.G25PDFURL; // Replace with the actual path to your PDF file
  link.download = "G5-Catalogue.pdf"; // Name of the downloaded file
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

class G5Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
    };
  }

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  render() {
    return (
      <>
        <div className="page-content bg-white">
          <div className="content-block">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-xl-4">
                  <label className="gradiant-label">
                    Heating Furnace G-5
                  </label>
                  <div className="card-body card-body-style">
                    <h4 style={{ textAlign: "center" }}>
                      Standard Power Rating
                    </h4>
                    <hr style={{ border: "2px solid black" }} />
                    <h5 style={{ textAlign: "center" }}>15 KW To 125 KW</h5>
                    <h5 style={{ textAlign: "center" }}>10 KHz To 100 KHz</h5>
                  </div>
                  <label className="gradiant-label">APPLICATION</label>
                  <div
                    className="card-body"
                    style={{
                      background: "#f4f4f4",
                      padding: "15px 10px",
                      marginBottom: "10px",
                      border: "5px solid #fff",
                      boxShadow: "0 0 7px 1px rgba(0,0,0,.26)",
                      borderRadius: "10px",
                    }}
                  >
                    <div>
                      <i className="fa fa-gear mx-2"></i>
                      <span className="card-text">Forging Billet Heater</span>
                    </div>
                    <div>
                      <i className="fa fa-gear mx-2 my-3"></i>
                      <span className="card-text">Auto Component</span>
                    </div>
                    <div>
                      <i className="fa fa-gear mx-2"></i>
                      <span className="card-text">Fasteners</span>
                    </div>
                    <div>
                      <i className="fa fa-gear mx-2 my-3"></i>
                      <span className="card-text">Engineering Parts</span>
                    </div>
                  </div>
                </div>

                <div className="col-md-8" style={{ textAlign: "center" }}>
                  <div className="blog-post blog-lg blog-rounded ">
                    <div className="">
                      <img className="img-fluid" src={proimage} alt="image" />
                    </div>
                    <button
                      className="site-button black m-r5 my-2"
                      type="button"
                      onClick={this.openPopup}
                    >
                      <span className="site-button-inr">
                        Inquiry <i className="ti-email"></i>
                      </span>
                    </button>
                    <InquiryPopup
                      className="inq-pop"
                      show={this.state.isPopupOpen}
                      onClose={this.closePopup}
                    />

                    <button
                      className="site-button black m-r5"
                      type="button"
                      onClick={handleDownload}
                    >
                      <span className="site-button-inr">
                        Catalogue <i className="ti-download"></i>
                      </span>
                    </button>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>

          {/* start */}
          <div className="page-content " style={{ background: "#f4f4f4" }}>
                    <div className="content-block">                        
                    <div className="section-full content-inner video-section">
                            <div className="container">
                                <div className="section-content">
                                    <div className="row d-flex">
                                        <div className="col-lg-6 col-md-12 m-b30">
                                            <div className="video-bx">
                                                <img src={proimage1} alt="Signature" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 m-b30 align-self-center video-infobx">
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>RATTING (KW)</th>
                                                <th>DIA (MM)</th>
                                                <th>FREQUENCY (KHz)</th>
                                                <th>PRODUCTION (Kg/Hr)</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {jsonData.map((data) => (
                                                <tr key={data.id}>
                                                  <td>{data.ratting}</td>
                                                  <td>{data.dia}</td>
                                                  <td>{data.frq}</td>
                                                  <td>{data.production}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
          </div>  

          

          {/* end */}

          {/* <section className="content-block pt-100 pb-100">
            <div className="container">
              <table>
                <thead>
                  <tr>
                    <th>RATTING (KW)</th>
                    <th>DIA (MM)</th>
                    <th>FREQUENCY (KHz)</th>
                    <th>PRODUCTION (Kg/Hr)</th>
                  </tr>
                </thead>
                <tbody>
                  {jsonData.map((data) => (
                    <tr key={data.id}>
                      <td>{data.ratting}</td>
                      <td>{data.dia}</td>
                      <td>{data.frq}</td>
                      <td>{data.production}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section> */}

          <div
            className="content-block"
            style={{
              background: "#f4f4f4",
              paddingBottom: "30px",
              paddingTop: "30px",
            }}
          >
            <div
              id="masonry"
              className="dlab-blog-grid-2"
              style={{
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <div className="row">
                <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                  <img src={imgIcon} alt="icon-1" />
                  <span className="card-text" style={{ fontSize: "24px" }}>
                    Safety Interlock With Featurey
                  </span>
                  <div className="dlab-divider divider-2px bg-red" />

                  <ul
                    className="my-2 col-sm "
                    style={{ fontSize: "18px", fontWeight: "550" }}
                  >
                    <i
                      className="fa fa-gear "
                      style={{ fontSize: "18px", fontWeight: "550" }}
                    ></i>
                    <span className="mx-4">Negligible scale loss</span>
                  </ul>
                  <ul
                    className="my-2 col-sm "
                    style={{ fontSize: "18px", fontWeight: "550" }}
                  >
                    <i
                      className="fa fa-gear "
                      style={{ fontSize: "18px", fontWeight: "550" }}
                    ></i>
                    <span className="mx-4">
                      True temperature uniformity control
                    </span>
                  </ul>
                  <ul
                    className="my-2 col-sm "
                    style={{ fontSize: "18px", fontWeight: "550" }}
                  >
                    <i
                      className="fa fa-gear "
                      style={{ fontSize: "18px", fontWeight: "550" }}
                    ></i>
                    <span className="mx-4">Compact modular design</span>
                  </ul>
                  <ul
                    className="my-2 col-sm "
                    style={{ fontSize: "18px", fontWeight: "550" }}
                  >
                    <i
                      className="fa fa-gear "
                      style={{ fontSize: "18px", fontWeight: "550" }}
                    ></i>
                    <span className="mx-4">
                      Water temperature & pressure interlock
                    </span>
                  </ul>
                </div>

                <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                  <img src={imgIcon} alt="icon-1" />
                  <span className="card-text" style={{ fontSize: "24px" }}>
                    Related Products
                  </span>
                  <div className="dlab-divider divider-2px bg-red" />
                  <div className="row">
                    <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                      <button
                        class="site-button outline outline-2 black m-r15"
                        type="button"
                        style={{ width: "200px" }}
                      >
                        G-50
                      </button>
                      <button
                        class="site-button outline outline-2 black m-r15 my-4"
                        type="button"
                        style={{ width: "200px" }}
                      >
                        Longbar
                      </button>
                    </div>
                    <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                      <button
                        class="site-button outline outline-2 black m-r15"
                        type="button"
                        style={{ width: "200px" }}
                      >
                        G-25/G-30
                      </button>
                      <button
                        class="site-button outline outline-2 black m-r15 my-4"
                        type="button"
                        style={{ width: "200px" }}
                      >
                        Scan Master
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default G5Details;
